<template>
	<Layout>
		<article
			id="legal-pages"
			class="entry-content"
		>
			<header class="entry-header">
				<h1
					ref="pageTitleRef"
					class="entry-title"
				/>
			</header>
			<div ref="contentRef" />
		</article>
	</Layout>
</template>
<script setup>
import Layout from "~/components/layout/Legal.vue";

const $config = useRuntimeConfig();
let pageContent = null;
let pageTitle = null;

const pageTitleRef = ref(null);
const contentRef = ref(null);

const $route = useRoute();
const { current_hostname } = useRuntimeConfig().public;
const pageSlug = $route.name;

const transformedContent = computed(() => {
	if (pageContent) {
		const contentElement = document.createElement("div");
		contentElement.innerHTML = pageContent;

		const pElements = contentElement.querySelectorAll("p");

		pElements.forEach((pElement) => {
			if (pElement.innerHTML.includes("Source:Profit.ly")) {
				pElement.classList.add("wp-caption-text");
			}
			if (pElement.innerHTML.includes("Source:StocksToTrade")) {
				pElement.classList.add("wp-caption-text");
			}
		});

		pElements.forEach((pElement) => {
			const aElement = pElement.querySelector("a");
			if (aElement && aElement.innerHTML.includes("Source:")) {
				const sourceText = aElement.innerHTML.replace("Source:", "");
				aElement.innerHTML = sourceText;
				pElement.innerHTML = `Source: ${
					aElement.outerHTML
				}${pElement.innerHTML.replace(aElement.outerHTML, "")}`;
			}
		});

		return contentElement.innerHTML;
	} else {
		return this.pageContent;
	}
});

const fetchData = async () => {
	try {
		const response = await fetch(
			`${$config.public.hostname}wp-json/wp/v2/pages/64547/`
		);
		if (response.ok) {
			const renderedContent = await response.json();
			pageTitle = renderedContent.title.rendered;
			pageContent = renderedContent.content.rendered;
			pageTitleRef.value.innerHTML = pageTitle;
			contentRef.value.innerHTML = transformedContent.value;
		} else {
			throw new Error("Fetch request failed:", response.statusText);
		}
	} catch (e) {
		// eslint-disable-next-line no-console
		console.error(e);
	}
};

const checkForTocTitle = () => {
	if (pageContent) {
		const tocTitles = document.querySelectorAll(".toc_title");
		const toc = document.querySelector(".toc_list");

		if (tocTitles.length > 0) {
			tocTitles.forEach((tocTitle) => {
				const button = document.createElement("button");
				button.setAttribute("aria-label", "Toggle Table of Contents");
				button.innerHTML = `
						<span class="expand"> 
							<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
							<circle cx="12.5" cy="12.5" r="11.5" fill="#3094FB" stroke="#FCFCFD" stroke-width="2"/>
							<path d="M12.5 7.5V17.5" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
							<path d="M7.5 12.5H17.5" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
							</svg>
						</span>
						<span class="collapse"> 
							<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
							<circle cx="12.5" cy="12.5" r="11.5" fill="#3094FB" stroke="#FCFCFD" stroke-width="2"/>
							<path d="M7.5 12.5H17.5" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
							</svg>
						</span>`;
				button.addEventListener("click", () => {
					if (toc.classList.contains("active")) {
						button.classList.remove("active");
						toc.classList.remove("active");
					} else {
						button.classList.add("active");
						toc.classList.add("active");
					}
				});
				tocTitle.appendChild(button);
			});
		}
	}
};

onMounted(() => {
	fetchData().then(() => {
		useHead(() => {
			return {
				title: `${pageTitle} - Timothy Sykes`,
				link: [{ rel: "canonical", href: `${current_hostname}${pageSlug}/` }]
			};
		});
		checkForTocTitle();
	});
});
</script>
<style lang="scss" scoped>
@import "@assets/utils.scss";

:deep(h3) {
	font-size: 22px;
	padding-bottom: 25px;
}

:deep(.wp-caption-text) {
	font-size: 12px;
	text-align: center;
}

:deep(figure) {
	width: auto !important;
}

:deep(.have_bullets) {
	height: auto !important;
	padding-bottom: 12px;
}

:deep(p) {
	width: auto;

	@include breakpoint(lg) {
		width: 1006px;
	}
}

:deep(img) {
	max-width: none !important;
	width: 100%;
}
</style>
